import React from "react";
import { Card, CardHeader, Button, ListGroup, ListGroupItem, Progress } from "shards-react";

const AppView = props => (
  <Card small className="mb-4 pt-3">
    <CardHeader className="border-bottom text-center">
      <div className="mb-3 mx-auto">
        <img
          className="rounded-circle"
          src={ props.App.app_icon_url }
          alt={ props.App.name }
          width="110"
        />
      </div>
      <h4 className="mb-0">{ props.App.name }</h4>
      <span className="text-muted d-block mb-2">{ props.App.system_name }</span>

      	<a href={ props.App.ios_url } target="_blank">
			<Button outline size="sm" className="mb-2">
				View on IOS Store&nbsp;&nbsp;<i className="material-icons mr-1">trending_flat</i>
			</Button>
        </a>
        &nbsp;&nbsp;
        <a href={ props.App.android_url } target="_blank">
			<Button outline size="sm" className="mb-2">
				View on Android Store&nbsp;&nbsp;<i className="material-icons mr-1">trending_flat</i>
			</Button>
        </a>
    </CardHeader>
    <ListGroup flush>
      <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <strong className="text-muted d-block mb-2">
            App Complete
          </strong>
          <Progress
            className="progress-sm"
            value="100"
          >
            <span className="progress-value">
              100%
            </span>
          </Progress>
        </div>
      </ListGroupItem>
      <ListGroupItem className="p-4">
        <strong className="text-muted d-block mb-2">
          Description
        </strong>
        <span>{ props.App.description }</span>
      </ListGroupItem>
    </ListGroup>
  </Card>
);

export default AppView;
